module.exports = __webpack_public_path__ + "img/pl.403e15bc.svg";